import React, { useEffect, useState } from 'react';
import FactviewLogo from '../../images/FactviewLogo.png';
import '../../css/header.css';
import ProfileComponent from '../utilities/ProfileComponent.js';
import LanguageComponent from '../utilities/LanguageComponent.js';

function Header() {
  
  useEffect(() =>{
  }, []); // [] makes sure that this useEffect block only runs on the first render of the component
  
  useEffect(() =>{
  }, []);

  

  return (
      <header className="app-header">
        <div className="app-top-bar">
          <img src={FactviewLogo} className="header-img" alt="logo" />
          <div className="header-title">
            <p>Import Module</p>
          </div>
          <div className="header-options">
            <div className="language-container">
              <LanguageComponent></LanguageComponent>
            </div>
            <div className="profile-container">
              <ProfileComponent></ProfileComponent>
            </div>
          </div>
        </div>
      </header >
  );
}

export default Header;
